<template>
  <div>
    <LeftSidebar
      :visible="visible"
      baseClass="add-term-wrapper"
      :title="$lang.editTermState"
      :hasHeaderRightIcon="false"
    >
      <template>
        <FormLoading
          :class="{ 'padding-y-16': getLoading }"
          :loading="getLoading"
          :count="5"
        >
          <template>
            <TermStateForm
              :item="termStateData"
              :submitted="submitted"
              @setParameters="setParameters"
              @setSubmitted="setSubmitted"
              @handleSubmit="handleSubmit"
            />
          </template>
        </FormLoading>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          :loading="loading"
          @click="setSubmitted(true)"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import { FormLoading, Button } from "@/components/re-design/forms";
import TermStateForm from "./forms/TermStateForm.vue";
import { editTermState, getOneTermState } from "@/modules/profile/services";
import { inject, ref, toRefs, watch } from "vue";
import { generateError, toastAlert } from "@/shared/utils";

export default {
  components: { LeftSidebar, TermStateForm, FormLoading, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    termStateCode: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible, termStateCode } = toRefs(props);

    const handleClose = () => emit("handleClose");
    const handleFetchData = () => emit("handleFetchData");

    // get term state data
    const termCode = inject("TERM_CODE");
    const getLoading = ref(false);
    const termStateData = ref(null);
    const fetchData = async () => {
      try {
        getLoading.value = true;
        const response = await getOneTermState(termCode, termStateCode.value);
        termStateData.value = { ...response };
      } catch (error) {
        generateError(error);
      } finally {
        getLoading.value = false;
      }
    };

    const loading = ref(false);
    const parameters = ref({});
    const setParameters = (params) =>
      (parameters.value = {
        termCode,
        termStateCode: termStateCode.value,
        ...params,
      });
    const submitted = ref(false);
    const setSubmitted = (value) => (submitted.value = value);
    const handleSubmit = async () => {
      try {
        loading.value = true;
        const response = await editTermState(parameters.value);
        const { message } = response;
        toastAlert(message);
        handleClose();
        handleFetchData();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    // when visible is true get date
    watch(visible, (value) => value && fetchData());

    // return data to be used in template
    return {
      visible,
      loading,
      parameters,
      submitted,
      getLoading,
      termStateData,
      handleClose,
      setParameters,
      setSubmitted,
      handleSubmit,
    };
  },
};
</script>
